import { useEffect } from 'react';

import { RecentSearch } from '~/features/advanced-search/types';
import { api } from '~/redux/api/createApi';
import { ContextType } from '~/redux/api/methods/userPreferences';

export const useRecentSearches = (context: ContextType) => {
  const [getRecentSearches, recentSearchesResult] =
    api.endpoints.getRecentSearches.useLazyQuery();
  const { data, isLoading: isLoadingRecentSearches } = recentSearchesResult;
  const [updateRecentSearches] =
    api.endpoints.updateRecentSearches.useMutation();

  const pushRecentSearch = async (recentSearch: RecentSearch) => {
    if (!recentSearch.query?.length) return;

    const recentSearches = await getRecentSearches({ context }, false).unwrap();

    const isDuplicated = recentSearches?.data?.some(
      (search) =>
        JSON.stringify(search.query) === JSON.stringify(recentSearch.query),
    );
    if (isDuplicated) return;

    const newRecentSearches = [
      recentSearch,
      ...(recentSearches?.data ?? []).slice(0, 4),
    ];

    updateRecentSearches({
      context,
      recentSearches: newRecentSearches,
    });
  };

  useEffect(() => {
    getRecentSearches({ context }, false);
  }, []);

  return {
    recentSearches: data?.data ?? [],
    isLoadingRecentSearches,
    pushRecentSearch,
  };
};
